module.exports = __webpack_public_path__ + "media/relaxing_lofi.4c4f8c8b.wav";